import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const getImageUrl = (url) => {
  if (url && (url.startsWith('/uploads') || url.startsWith('/api/uploads'))) {
    return `${BACKEND_URL}${url}`;
  }
  return url;
};

export const ImageCarousel = ({ images = [], productName = '', onClick }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!images || images.length === 0) {
    // Show placeholder if no images
    return (
      <div className="relative aspect-square rounded-lg bg-[#121212] overflow-hidden cursor-pointer" onClick={onClick}>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center">
            <div className="text-4xl font-bold text-muted-foreground/30 mb-2">
              {productName.split(' ')[0]}
            </div>
            <div className="text-xs text-muted-foreground/50">Imagen próximamente</div>
          </div>
        </div>
      </div>
    );
  }

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <div
      className="relative aspect-square rounded-lg bg-[#121212] overflow-hidden group cursor-pointer"
      onClick={onClick}
    >
      {/* Main Image */}
      <img
        src={getImageUrl(images[currentIndex])}
        alt={`${productName} - Imagen ${currentIndex + 1}`}
        className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        onError={(e) => {
          e.target.onerror = null;
          e.target.style.display = 'none';
        }}
      />

      {/* Navigation Arrows - Only show if multiple images */}
      {images.length > 1 && (
        <>
          <button
            onClick={(e) => {
              e.stopPropagation();
              goToPrevious();
            }}
            className="absolute left-2 top-1/2 -translate-y-1/2 p-1.5 rounded-full bg-black/60 text-white opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black/80"
          >
            <ChevronLeft className="h-4 w-4" />
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              goToNext();
            }}
            className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-full bg-black/60 text-white opacity-0 group-hover:opacity-100 transition-opacity hover:bg-black/80"
          >
            <ChevronRight className="h-4 w-4" />
          </button>

          {/* Dot Indicators */}
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5">
            {images.map((img, index) => (
              <button
                key={img}
                onClick={(e) => {
                  e.stopPropagation();
                  setCurrentIndex(index);
                }}
                className={`h-1.5 rounded-full transition-all ${
                  index === currentIndex
                    ? 'w-6 bg-[#39FF14]'
                    : 'w-1.5 bg-white/50 hover:bg-white/80'
                }`}
              />
            ))}
          </div>

          {/* Image Counter */}
          <div className="absolute top-2 right-2 px-2 py-1 rounded bg-black/60 text-white text-xs font-medium">
            {currentIndex + 1}/{images.length}
          </div>
        </>
      )}
    </div>
  );
};
